import SimpleBar from "simplebar";

const scrolls = [];

document.querySelectorAll(`[data-simplebar]`).forEach((elm) => {
    const w =
        innerWidth > 1024
            ? (160 / 1280) * innerWidth
            : (120 / 375) * innerWidth;

    scrolls.push(
        new SimpleBar(elm, {
            autoHide: false,
            scrollbarMinSize: w,
            scrollbarMaxSize: w,
        })
    );
});

let resizeTimeout;

window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        scrolls.forEach((scrl) => {
            scrl.recalculate();
        });
    }, 400);
});
